import { render, staticRenderFns } from "./DeliveryMain.vue?vue&type=template&id=59e5fcdc&scoped=true&"
import script from "./DeliveryMain.vue?vue&type=script&lang=js&"
export * from "./DeliveryMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e5fcdc",
  null
  
)

export default component.exports